import request from '@/utils/request'

export function updateAirship2Cfg(data) {
  return request({
    url: 'api/v1/airship2/updateCfg',
    method: 'post',
    data: data
  })
}

export function getAirship2CfgList(data) {
  return request({
    url: 'api/v1/airship2/getList',
    method: 'post',
    data: data
  })
}

export function delAirship2Cfg(data) {
  return request({
    url: 'api/v1/airship2/delFirst',
    method: 'delete',
    data: data
  })
}

export function importAirship2Cfg(data) {
  return request({
    url: 'api/v1/airship2/import',
    method: 'post',
    data: data
  })
}

export function exportAirship2Cfg() {
  return request({
    url: 'api/v1/airship2/export',
    method: 'post'
  })
}
